<template>
	<el-card shadow="never">
		<div class="header-row" slot="header">
			<div class="title">预警提醒</div>
		</div>
		<div class="entry-grid">
			<div
				v-for="item in entries"
				:key="item.name"
				class="entry-item"
				:style="{
					'--color': item.color,
				}">
				<div class="entry-name">{{ item.name }}</div>
				<div class="entry-value">{{ item.value }}</div>

				<div class="entry-desc">{{ item.desc }}</div>
			</div>
		</div>
	</el-card>
</template>

<script>
	import { getWarningReminder } from '@/api/asset/assetLedgerApi';
	import { getCommunityId } from '@/utils/vc';

	export default {
		name: 'WarningReminder',
		data() {
			return {
				entries: [
					{ name: '合同到期', desc: '30天内到期', value: 0, color: '#EF4444' },
					{ name: '租金逾期', desc: '超过7天未缴', value: 0, color: '#F97316' },
					{ name: '资产闲置', desc: '超过90天', value: 0, color: '#64748B' },
					{ name: '巡检未完成', desc: '7日内未完成的巡检项', value: 0, color: '#2B8CEE' },
				],
			};
		},
		created() {
			this.loadWarningReminder();
		},
		methods: {
			loadWarningReminder() {
				const communityId = getCommunityId();
				if (!communityId) return;
				getWarningReminder(communityId).then(res => {
					if (!res) return;
					this.entries[0].value = res.contractExpiringCount || 0;
					this.entries[1].value = res.rentOverdueCount || 0;
					this.entries[2].value = res.assetIdleCount || 0;
					this.entries[3].value = res.inspectionPendingCount || 0;
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.el-card) {
		.el-card__body {
			box-sizing: border-box !important;
		}
	}

	.header-row {
		display: flex;
		justify-content: space-between;
		height: 20px;
	}

	.title {
		font-weight: bold;
	}

	.entry-grid {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		gap: 12px;
	}
	.entry-item {
		width: calc(100% / 2 - 12px);
		height: 69px;
		box-sizing: border-box;
		padding: 5px 12px;
		border-radius: 4px;
		cursor: pointer;
		border: 1px solid color-mix(in srgb, var(--color) 25%, white);
		background-color: color-mix(in srgb, var(--color) 5%, white);
		transition: all 0.3s ease;
	}

	.entry-item:hover {
		background-color: color-mix(in srgb, var(--color) 15%, white);
		transform: translateY(-4px);
	}

	.entry-name {
		font-weight: 500;
		font-size: 14px;
		color: var(--color);
	}

	.entry-value {
		font-weight: bold;
		font-size: 20px;
		color: #0f172a;
	}

	.entry-desc {
		font-size: 12px;
		color: #999;
	}
</style>